import { Link } from "react-router-dom";
import { fmtMoney } from "@/lib/format";
import { Card, CardContent } from "@/components/ui/card";

export const TopSupportersCard = ({ data }) => (
  <Card className="shadow-sm" data-testid="top-supporters-card">
    <CardContent className="p-6">
      <h2 className="text-2xl font-serif font-semibold mb-4">Top supporters in {data?.year || new Date().getFullYear()}</h2>
      {!data || !data.top_supporters || data.top_supporters.length === 0 ? (
        <p className="text-muted-foreground text-sm" data-testid="no-supporters-message">No activity yet this year.</p>
      ) : (
        <ol className="divide-y divide-border">
          {data.top_supporters.map((s, i) => (
            <li key={s.customer_id}>
              <Link to={`/customers/${s.customer_id}`} className="flex items-center gap-3 py-2.5 group" data-testid={`top-supporter-${i + 1}`}>
                <span className="h-7 w-7 shrink-0 rounded-full bg-secondary text-secondary-foreground text-xs font-semibold flex items-center justify-center">{i + 1}</span>
                <span className="flex-1 text-sm font-medium group-hover:text-primary transition-colors duration-200">{s.name}</span>
                <span className="text-xs text-muted-foreground">{s.orders} order{s.orders === 1 ? "" : "s"}</span>
                <span className="text-sm font-semibold w-24 text-right">{fmtMoney(s.amount)}</span>
              </Link>
            </li>
          ))}
        </ol>
      )}
    </CardContent>
  </Card>
);
